import React from 'react';
import { AdvancedValueMap } from '../../types';

interface AdvancedValueMapVisualProps {
  valueMap: AdvancedValueMap;
}

export const AdvancedValueMapVisual: React.FC<AdvancedValueMapVisualProps> = ({ valueMap }) => {
  const { customerName, businessPriorities, digitalPriorities, externalChallenges, internalChallenges } = valueMap;

  return (
    <div id="value-map-export" className="w-full max-w-5xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden border border-gray-200">
      {/* Header - Customer Name */}
      <div className="bg-gradient-to-r from-orange-400 to-orange-500 px-8 py-6">
        <h1 className="text-2xl font-bold text-white">
          WHAT WE KNOW ABOUT {customerName.toUpperCase()}
        </h1>
      </div>

      {/* Business Priorities - Orange Section */}
      <div className="bg-gradient-to-r from-orange-300 to-orange-400 px-8 py-6">
        <h2 className="text-xl font-bold text-gray-800 mb-4">Business Priorities</h2>
        <ul className="space-y-2 text-gray-800">
          {businessPriorities.map((item, idx) => (
            item && item.trim() ? (
              <li key={idx} className="flex gap-2">
                <span>•</span>
                <span className="text-sm">{item}</span>
              </li>
            ) : null
          ))}
        </ul>
      </div>

      {/* Digital CxO Priorities - Gray Section */}
      <div className="bg-gray-200 px-8 py-6">
        <h2 className="text-xl font-bold text-gray-800 mb-4 text-center">Digital CxO Priorities</h2>
        <ul className="space-y-2 text-gray-700">
          {digitalPriorities.map((item, idx) => (
            item && item.trim() ? (
              <li key={idx} className="flex gap-2">
                <span>•</span>
                <span className="text-sm">{item}</span>
              </li>
            ) : null
          ))}
        </ul>
      </div>

      {/* Challenges - Two Column Layout */}
      <div className="grid grid-cols-2 divide-x divide-orange-400">
        {/* External-Facing Challenges - Left Column */}
        <div className="bg-white px-8 py-6">
          <h2 className="text-lg font-bold text-gray-800 mb-4 text-center">External-Facing Challenges</h2>
          <ul className="space-y-2 text-gray-700">
            {externalChallenges.map((item, idx) => (
              item && item.trim() ? (
                <li key={idx} className="flex gap-2">
                  <span>•</span>
                  <span className="text-sm">{item}</span>
                </li>
              ) : null
            ))}
          </ul>
        </div>

        {/* Internal-Facing Challenges - Right Column */}
        <div className="bg-white px-8 py-6">
          <h2 className="text-lg font-bold text-gray-800 mb-4 text-center">Internal-Facing Challenges</h2>
          <ul className="space-y-2 text-gray-700">
            {internalChallenges.map((item, idx) => (
              item && item.trim() ? (
                <li key={idx} className="flex gap-2">
                  <span>•</span>
                  <span className="text-sm">{item}</span>
                </li>
              ) : null
            ))}
          </ul>
        </div>
      </div>

      {/* Footer - Cloudflare Capabilities */}
      <div className="bg-gray-200 px-8 py-4">
        <h3 className="text-center font-bold text-gray-700">Cloudflare Capabilities</h3>
      </div>
    </div>
  );
};
